module.exports = __webpack_public_path__ + "img/logo.3bef66a3.png";